/*
 * LOOKS page (sections/exo_looks_page.liquid): closes the mobile/tablet
 * season dropdown once a season is picked.
 *
 * Season switching itself is pure CSS (radio inputs + :has(), no JS —
 * see the section file's own comment), which is exactly why this needs a
 * few lines of JS: picking a category on the SHOP page navigates to a new
 * URL, so its dropdown checkbox resets for free on page load. Picking a
 * season here is a client-side swap with no navigation, so the dropdown's
 * own checkbox never gets touched by that and stays checked/open.
 */
(function () {
  var toggle = document.querySelector('.exo-looks-page-dropdown__toggle');
  if (!toggle) return;

  var radios = document.querySelectorAll('.exo-looks-page__radio');
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      toggle.checked = false;
    });
  });
})();
